import { Injector } from '@/config/dependency-injection'
import { AdministrationModule } from '@/business/administration/store/administration-module'

export function impersonateOrganisation(organisationId: number): void {
  const adminModule = Injector.get(AdministrationModule)

  adminModule
    .fetchAccounts({
      organisationId: organisationId,
    })
    .then(accounts => accounts.find(account => account.organisation.id === organisationId))
    .then(account => {
      if (account) {
        adminModule.impersonateAccount({
          username: account.email,
        })
      }
    })
}
